// Movimientos y tipos de tarjeta del informe de frecuencia.
import { parkingFrequencyEvents, parkingTicketTypes } from "../model/parkingVisitAdapter";
import axiosInstance from "core/api/axiosInstance";
import { ticketValue, validateFrequencyFilters } from "../model/frequencyModel";
export { processFrequencyData } from "../model/frequencyModel";

export const getHistoryService = async (params = {}, signal = null) => {
  try {
    const error = validateFrequencyFilters(params);
    if (error) throw new Error(error);
    const configuredEndpoint = process.env.REACT_APP_FRECUENCIA_API_URL;
    const endpoint = configuredEndpoint || "/api/isrr/get-frecuency";
    const query = new URLSearchParams({ startDate: params.startDate, endDate: params.endDate });
    const selected = (params.ticketTypes || []).map(ticketValue).filter(Boolean);
    if (selected.length) query.set("ticketTypes", JSON.stringify(selected));
    query.set("startAt", `${params.startDate}T00:00:00-05:00`);
    query.set("endAt", `${params.endDate}T23:59:59.999-05:00`);
    query.set("timeZone", "America/Bogota");
    const { data } = await axiosInstance.get(
      `${endpoint}${endpoint.includes("?") ? "&" : "?"}${query}`,
      { signal }
    );
    if (!data || !Array.isArray(data.data))
      throw new Error(
        data?.message || data?.msm || "El servidor no devolvió una lista de movimientos válida."
      );
    if (data.code !== undefined && data.code !== 0)
      throw new Error(data.message || data.msm || "No se pudo consultar el informe.");
    if (
      data.pagination?.hasMore ||
      (Number.isFinite(Number(data.count)) && Number(data.count) > data.data.length)
    )
      throw new Error(
        "El historial recibido está incompleto. El endpoint debe devolver todos los movimientos del rango."
      );
    return {
      success: true,
      data: parkingFrequencyEvents(data.data),
      ticketTypes: [
        ...(Array.isArray(data.ticket_types) ? data.ticket_types : []),
        ...parkingTicketTypes(data.data),
      ],
      source: "report",
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error al obtener el historial",
      data: [],
      isCanceled: signal?.aborted || error.code === "ERR_CANCELED",
    };
  }
};
